<template>
    <PlatformLayout
        :layout-class="platformLayoutClass"
        title="Уведомления"
        :show-guest-banner="false"
    >
            <div class="notice-page">
            <div class="notice-page__tabs">    
                    <swiper 
                    class="notice-page__tabs-swiper"
                    @swiper="getSwiperCategory" 
                    :breakpoints="{
                        0: {
                            slidesPerView: 'auto'
                        }
                    }"
                    :spaceBetween="50"
                    :speed="500"
                    :lazy="true" 
                > 
                    <swiper-slide v-for="(tab, index) in roleByTabs" 
                        :key="index"
                        :class="{ customTab: selectedTab === tab.id }"
                        @click="selectTab(tab.id, index)"
                        ref="tabs"
                    > 
                        {{ tab.name }}
                    </swiper-slide> 
                </swiper>
            </div>
            <div class="notice__block">
                    <div class="notice__block__in" v-for="item in currentNotices" :key="item">
                        <div class="notice__block__in__top" v-if="item.type == 'assignment' || item.type == 'course_deadline' || item.type == 'other' || item.type === 'scholarship_deadline'  || item.type === 'approved_program_deadline'">
                            <div class="notice__block__in__top__left">
                                <img src="@/assets/icons/system.svg"/>
                                <div class="notice__block__in__top__left__info">
                                    <div class="notice__block__in__top__left__info__top" :class="{assignment: item.data?.assignment}">
                                        <p class="name" v-if="$store.state.role == 'user'">Система</p>
                                        <p class="name" v-else>{{ item?.data?.client_name }} ID:{{ item?.data?.client_id }}</p>
                                        <p class="status">{{ item.body }} <span v-if="item.type == 'other'">{{ item?.remained }}</span></p>
                                        <p class="statusTime" :style="{color: item.color}" >{{ item?.data?.date }}</p>
                                    </div>
                                    <p class="date">{{ item.time }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="notice__block__in__top" v-if="item.type == 'approval_request'">
                            <div class="notice__block__in__top__left">
                                <img src="@/assets/icons/system.svg"/>
                                <div class="notice__block__in__top__left__info">
                                    <div class="notice__block__in__top__left__info__top">
                                        <p class="name"><span>Эксперт</span> {{ item?.data?.expert_name }} ID:{{ item?.data?.expert_id }}</p>
                                        <p class="status">{{ item.body }}</p>
                                        <p class="name">{{ item?.data?.client_name }} ID:{{ item?.data?.client_id }}</p>
                                    </div>
                                    <p class="date">{{ item.time }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="notice__block__in__comments" v-if="item.type == 'comment' || item.type == 'comment_feedback'">
                            <div class="correct">
                                <div class="correct__top">
                                    <img src="@/assets/icons/system.svg"/>
                                    <div class="correct__top__info">
                                        <div class="correct__top__info__top">
                                            <p class="name" v-if="item.type == 'comment'">НО12 {{ item.data.chief_name }} ID:{{ item.data.chief_id }}</p>
                                            <p class="name" v-if="item.type == 'comment_feedback'">{{ item.data.client_name }} ID:{{ item.data.client_id }}</p>
                                            <p class="status">{{ item.body }} <span v-if="item.type == 'comment_feedback'">о программе {{ item.data.program_name }}</span></p>
                                            <p class="status" :style="{color: item.color}">{{ item.title }}</p>
                                            <p class="name" v-if="item.type == 'comment'">{{ item.data.client_name }} ID:{{ item.data.client_id }}</p>
                                        </div>
                                        <!-- Ссылка на файл -->
                                        <p v-if="item.data.file_url">
                                            <a
                                            :href="item.data.file_url"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            class="file-link"
                                            >
                                            📎 Скачать прикреплённый файл
                                            </a>
                                        </p>
                                        <p class="date">{{ item.time }}</p>
                                    </div>
                                </div>
                                <textarea v-model="item.text"></textarea>
                                <button v-if="item.type == 'comment_feedback'" @click="$router.push(`/programs/${item.data.program_id}`)">Перейти</button>
                                <button v-if="item.data.status == 'rejected'" @click="$router.push(`/curator/users/${item.data.client_id}?tab=3`)">Исправить</button>
                                <button v-if="item.data.status == 'approved'" @click="$router.push(`/curator/users/${item?.data?.client_id}?tab=4`)">Открыть</button>
                            </div>
                        </div>
                        <div class="line"></div>
                    </div>
            </div>
            </div>
    </PlatformLayout>
</template>
<script>
import PlatformLayout from "@/components/platform/PlatformLayout.vue";
import { Swiper, SwiperSlide, } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import axios from "axios";
import SwiperCore, { A11y, Autoplay } from "swiper";
import { Navigation, Pagination, EffectCoverflow } from 'swiper';
import "swiper/swiper.min.css";
SwiperCore.use([Navigation, Pagination, A11y, Autoplay, EffectCoverflow])
export default {
    components: {
        Swiper,
        SwiperSlide,
        PlatformLayout,
    },
    data() {
        return {
            selectedTab: 0,
            openExtend: false,
            swiperRefCategory: null,
            swiperRef: null,
            activeSwiperIndex: 0,
            notices: [],
            allNotices: [],
            tabs: [
                {
                    id: 0,
                    name: 'Все'
                },
                {
                    id: 1,
                    name: 'Дедлайны'
                },
                // {
                //     id: 2,
                //     name: 'Заявки'
                // }
            ],
            breakpoints: {
                0: {
                    slidesPerView: 3.4,
                    spaceBetween: 20,
                },
            },
        };
    },
    methods: {
        selectTab(id, index) {
            this.selectedTab = id;
            this.swiperRefCategory?.slideTo(index, 500);
            this.scrollToTop();
        },
        getSwiperCategory(swiper) {
            this.swiperRefCategory = swiper;
            this.activeSwiperIndex = swiper.activeIndex;
        },
        scrollToTop() {
            window.scrollTo(0,0);
        },
        async getNotifications() {
            try {
                const res = await axios.get(`/notifications`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    }
                })
                if (res.data) {
                    const data = Array.isArray(res.data?.data)
                        ? res.data.data
                        : Array.isArray(res.data?.data?.data)
                            ? res.data.data.data
                            : [];
                        this.allNotices = data;
                    console.log('Notices', this.allNotices)
                }
            } catch (err) {
                console.error(err);
            }
        }
    },
    computed: {
        platformLayoutClass() {
            if (this.$store.state.role === 'supervisor' || this.$store.state.role === 'chief') return 'mainStyle3';
            if (this.$store.state.role === 'curator' || this.$store.state.role === 'expert') return 'mainStyle';
            return 'mainStyle1';
        },
         deadlineNotices() {
            return this.allNotices.filter(item => item.type === 'course_deadline' || item.type === 'scholarship_deadline'  || item.type === 'approved_program_deadline'  || item.type === 'other');
        },
        assignmentNotices() {
            return this.allNotices.filter(item => item.type === 'assignment');
        },
        currentNotices() {
            if (this.selectedTab === 0) {
                return this.allNotices;
            } else if (this.selectedTab === 1) {
                return this.deadlineNotices;
            } else if (this.selectedTab === 2) {
                return this.assignmentNotices;
            } else {
                return [];
            }
        },
        roleByTabs() {
            const role = localStorage.getItem("user_role");
            if (role === 'curator') {
                return this.tabs.filter(tab => tab.id !== 2); // Curators don't see 'assignment' tab
            } else if (role === 'supervisor') {
                return this.tabs.filter(tab => tab.id !== 2 && tab.id !== 1); // Supervisors don't see 'assignment' tab
            } else if (role === 'expert' || role === 'chief') {
                return this.tabs.filter(tab => tab.id !== 1);
            } else {
                return this.tabs; // Other roles see all tabs
            }
        }
    },
    async mounted() {
        await this.getNotifications();
    }
};
</script>
<style lang="scss" scoped>
.line{
    border-top: 1px solid #0000001A;
    width: 100%;
}
select{
    border: 1px solid #0000001A;
    padding: 5px;
    border-radius: 10px;
    cursor: pointer;
}
.correct {
    display: flex;
    flex-direction: column;
    gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    &__top{
        display: flex;
        gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        align-items: stretch;
        &__info{
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            width: 100%;
            &__top{
                display: flex;
                flex-wrap: wrap;
                gap: 5px;
                .name{
                    font-weight: 700;
                }
            }
        }
    }
    textarea{
        width: 100%;
        padding: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        border-radius: 10px;
        background-color: #11415D;
        color: white;
        font-weight: 600;
        resize: none;
        min-height: 150px;
    }
}
.status{
    color: #0000008A;
}
.notice-page {
    display: flex;
    flex-direction: column;
    gap: min(max(20px, calc(1.25rem + ((1vw - 7.68px) * 0.8681))), 28px);

    &__tabs {
        font-weight: 600;
        font-size: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 28px);
        color: #00000026;
    }

    &__tabs-swiper {
        width: 100%;

        .swiper-slide {
            cursor: pointer;
            width: fit-content;
        }

        .customTab {
            color: #111827;
        }
    }

    button {
        background-color: #11415D;
        color: white;
        padding: min(max(6px, calc(0.375rem + ((1vw - 7.68px) * 0.5208))), 12px);
        border: none;
        height: fit-content;
        border-radius: 10px;
        width: fit-content;
        cursor: pointer;
    }
}

.notice__block {
        display: flex;
        flex-direction: column;
        gap: min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px); 
        &__in{
            display: flex;
            flex-direction: column;
            gap: min(max(24px, calc(1.5rem + ((1vw - 7.68px) * 1.3889))), 40px);
            &__top{
                display: flex;
                justify-content: space-between;
                gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
                &__left{
                    display: flex;
                    gap: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
                    align-items: stretch;
                    img{
                        width: 80px;
                        aspect-ratio: 1;
                    }
                    &__info{
                        display: flex;
                        gap: 10px;
                        justify-content: center;
                        flex-direction: column;
                        &__top{
                            display: flex;
                            flex-wrap: wrap;
                            gap: 5px;
                            align-items: center;
                            font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);
                            .name, .statusTime{
                                font-weight: 600;
                            }
                        }
                        .date{
                            font-size: min(max(13px, calc(0.8125rem + ((1vw - 7.68px) * 0.434))), 18px);
                            color: #0000008A;
                        }
                    }
                }
            }
            &__comments{
                display: flex;
                flex-direction: column;
                gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
            }
        }
}
.file-link {
  color: #3498db;
  text-decoration: underline;
  text-underline-offset: 2px;
  word-break: break-all;
  display: inline-block;
  margin: 4px 0;
  transition: all 0.3s ease;

  &:hover {
    text-underline-offset: 4px;
  }
}
</style>